import React, { Component } from 'react';

export class StockLocationListing extends Component {
    constructor(props) {
        super(props);
    };

    render() {

        var background = "#f4f4f4";

        if (this.props.stockData.quantity > 0) {
            background = "#e8f7e4";
        }

        // Compact comma separated barcode list (if provided at parent level)
        let barcodeListContent;
        if (this.props.barcodesLoading) {
            barcodeListContent = <span style={{ color: '#999' }}>Loading barcodes...</span>; // simple text placeholder
        } else if (this.props.barcodes && this.props.barcodes.length > 0) {
            barcodeListContent = <span>{this.props.barcodes.join(', ')}</span>;
        } else {
            barcodeListContent = <span style={{ color: '#999' }}>No barcodes</span>;
        }

        return (
            <div style={{ position: "relative", border: "2px solid lightgrey", margin: "5px", padding: "5px", background: background }}>
                <p className="item-large-heading">
                    <b>{this.props.stockData.location.identifier}</b> [{this.props.stockData.location.barcode}]
                    <span style={{ float: "right", textAlign: "right", alignContent: "top" }}>
                        Qty: {this.props.stockData.quantity}
                    </span>
                    <br />
                    {this.props.stockData.store.name}</p>
                <p className="item-large-description">
                    Description: {this.props.stockData.location.description}<br />
                    <small><b>Barcodes:</b> {barcodeListContent}</small>
                </p>
            </div>
        );
    }
}
